<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
    <div class="page-card-body" ref="pageRoot">
      <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
        <el-input v-model="keyword" placeholder="订单编号/寄件人/收件人/手机号" style="width:280px" clearable @keyup.enter.native="load" />

        <el-select v-model="orderType" placeholder="订单类型" clearable style="width:170px" @change="load">
          <el-option label="门到港" :value="1" />
          <el-option label="港到门" :value="2" />
          <el-option label="不正常行李" :value="3" />
          <el-option label="预留物品" :value="4" />
        </el-select>

        <el-select v-model="status" placeholder="状态" clearable style="width:170px" @change="load">
          <el-option v-for="(v,k) in STATUS_TEXT" :key="k" :label="v" :value="k" />
        </el-select>

        <el-select v-model="payStatus" placeholder="支付状态" clearable style="width:150px" @change="load">
          <el-option label="未支付" :value="1" />
          <el-option label="已支付" :value="2" />
        </el-select>

        <el-select v-model="refundStatus" placeholder="退款状态" clearable style="width:150px" @change="load">
          <el-option label="未退款" :value="1" />
          <el-option label="退款中" :value="2" />
          <el-option label="退款成功" :value="3" />
          <el-option label="退款失败" :value="4" />
        </el-select>

        <el-button type="primary" @click="load">查询</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="success" :loading="exporting" @click="exportExcel">导出</el-button>

      </div>

      <el-table :data="list" :height="tableHeight" style="width:100%;" size="small" border>
        <el-table-column prop="orderCode" label="订单编号" width="180" />
        <el-table-column prop="partnerName" label="下单来源" width="140" />

        <el-table-column prop="orderType" label="订单类型" width="80">
          <template slot-scope="s">{{ orderTypeText(s.row.orderType) }}</template>
        </el-table-column>

        <el-table-column prop="startAddressCn" label="出发地址" min-width="150" />
        <el-table-column prop="endAddressCn" label="到达地" min-width="150" />

        <el-table-column label="出发机场" width="150">
          <template slot-scope="s">{{ airportText(s.row.departAirportCn, s.row.departAirport) }}</template>
        </el-table-column>
        <el-table-column label="到达机场" width="150">
          <template slot-scope="s">{{ airportText(s.row.arriveAirportCn, s.row.arriveAirport) }}</template>
        </el-table-column>

        <el-table-column prop="senderName" label="寄件人" width="100" />
        <el-table-column prop="senderPhone" label="寄件电话" width="120" />
        <el-table-column prop="consigneeName" label="收件人" width="100" />
        <el-table-column prop="consigneePhone" label="收件电话" width="120" />

        <el-table-column label="状态" width="100">
          <template slot-scope="s">
            <el-tag :type="statusTagType(s.row.status)">{{ statusText(s.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" width="110">
          <template slot-scope="s">
            <el-tag :type="s.row.payStatus===2?'success':'info'">{{ payStatusText(s.row.payStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单金额" width="120">
          <template slot-scope="s">¥{{ Number(s.row.orderAmount || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="取消状态" width="110">
          <template slot-scope="s">
            <el-tag :type="(s.row.status||'').toString()==='21'?'danger':'info'">{{ (s.row.status||'').toString()==='21'?'已取消':'未取消' }}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="退款状态" width="110">
          <template slot-scope="s">
            <el-tag :type="refundTagType(s.row.refundStatus)">{{ refundStatusText(s.row.refundStatus) }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="预约取件时间" width="220">
          <template slot-scope="s">{{ pickupTimeText(s.row) }}</template>
        </el-table-column>
        <el-table-column prop="cTime" label="创建时间" width="160" />

        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="s">
            <el-button type="text" @click="openDetail(s.row)">详情</el-button>
            <el-button type="text" @click="openLogs(s.row)">日志</el-button>
            <el-button type="text" @click="openImages(s.row)">图片</el-button>
            <el-button v-if="canRefund(s.row)" type="text" style="color:#ef4444;" @click="openRefund(s.row)">取消/退款</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div ref="pagerBar" class="pager-bar">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page.sync="pageNum"
          :page-size="pageSize"
          :total="total"
          @current-change="load"
        />
      </div>
    </div>

    <el-dialog
      title="订单详情"
      :visible.sync="detailDlg"
      fullscreen
      destroy-on-close
    >
      <div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-start;">
        <el-card style="flex:1;min-width:420px;">
          <div style="font-weight:700;margin-bottom:8px;">基础信息</div>
          <div class="kv"><span class="k">订单编号</span><span class="v">{{ detail.orderCode || '-' }}</span></div>
          <div class="kv"><span class="k">订单类型</span><span class="v">{{ orderTypeText(detail.orderType) }}</span></div>
          <div class="kv"><span class="k">状态</span><span class="v">{{ statusText(detail.status) }}</span></div>
          <div class="kv"><span class="k">支付状态</span><span class="v">{{ payStatusText(detail.payStatus) }}</span></div>
          <div class="kv"><span class="k">退款状态</span><span class="v">{{ refundStatusText(detail.refundStatus) }}</span></div>
          <div class="kv"><span class="k">下单来源</span><span class="v">{{ detail.partnerName || '-' }}</span></div>
          <div class="kv"><span class="k">创建时间</span><span class="v">{{ detail.cTime || '-' }}</span></div>
        </el-card>

        <el-card style="flex:1;min-width:420px;">
          <div style="font-weight:700;margin-bottom:8px;">地址与联系人</div>
          <div class="kv"><span class="k">出发地址</span><span class="v">{{ detail.startAddressCn || '-' }}</span></div>
          <div class="kv"><span class="k">到达地</span><span class="v">{{ detail.endAddressCn || '-' }}</span></div>
          <div class="kv"><span class="k">出发机场</span><span class="v">{{ airportText(detail.departAirportCn, detail.departAirport) }}</span></div>
          <div class="kv"><span class="k">到达机场</span><span class="v">{{ airportText(detail.arriveAirportCn, detail.arriveAirport) }}</span></div>
          <div class="kv"><span class="k">寄件人</span><span class="v">{{ detail.senderName || '-' }}（{{ detail.senderPhone || '-' }}）</span></div>
          <div v-if="!isReserved(detail)" class="kv"><span class="k">收件人</span><span class="v">{{ detail.consigneeName || '-' }}（{{ detail.consigneePhone || '-' }}）</span></div>
          <div class="kv"><span class="k">预约取件时间</span><span class="v">{{ pickupTimeText(detail) }}</span></div>
        </el-card>

        <el-card v-if="isReserved(detail)" style="flex:1;min-width:420px;">
          <div style="font-weight:700;margin-bottom:8px;">收货人信息一</div>
          <div class="kv"><span class="k">收货人姓名</span><span class="v">{{ detail.consigneeName || '-' }}</span></div>
          <div class="kv"><span class="k">收货人电话</span><span class="v">{{ detail.consigneePhone || '-' }}</span></div>
          <div class="kv"><span class="k">收货人地址1</span><span class="v">{{ detail.endAddressCn || detail.endAddress || '-' }}</span></div>
          <div class="kv"><span class="k">物品信息</span><span class="v">{{ detail.itemInfo || '-' }}</span></div>
        </el-card>

        <el-card v-if="isReserved(detail)" style="flex:1;min-width:420px;">
          <div style="font-weight:700;margin-bottom:8px;">收货人信息二</div>
          <div class="kv"><span class="k">收货人2姓名</span><span class="v">{{ detail.consignee2Name || '-' }}</span></div>
          <div class="kv"><span class="k">收货人2电话</span><span class="v">{{ detail.consignee2Phone || '-' }}</span></div>
          <div class="kv"><span class="k">收货人地址2</span><span class="v">{{ detail.consignee2AddressCn || detail.consignee2Address || '-' }}</span></div>
        </el-card>

        <el-card style="flex:1;min-width:420px;">
          <div style="font-weight:700;margin-bottom:8px;">金额与航班</div>
          <div class="kv"><span class="k">订单总金额</span><span class="v">{{ detail.totalOrderAmount || '-' }}</span></div>
          <div class="kv"><span class="k">实际应付</span><span class="v">{{ detail.orderAmount || '-' }}</span></div>
          <div class="kv"><span class="k">已支付</span><span class="v">{{ detail.paidAmount || '-' }}</span></div>
          <div class="kv"><span class="k">航班时间</span><span class="v">{{ flightDateText(detail) }}</span></div>
          <div class="kv"><span class="k">航班号</span><span class="v">{{ detail.flightNo || '-' }}</span></div>
          <div v-if="isReserved(detail)" class="kv"><span class="k">座位号</span><span class="v">{{ detail.seatNo || '-' }}</span></div>
          <div class="kv"><span class="k">航司</span><span class="v">{{ detail.carrier || '-' }}</span></div>
        </el-card>

        <el-card style="width:100%;">
          <div style="font-weight:700;margin-bottom:8px;">图片</div>
          <div v-if="images.length" style="display:flex;gap:10px;flex-wrap:wrap;">
            <el-image
              v-for="it in images"
              :key="it.id"
              :src="it.path"
              :preview-src-list="imagesPreview"
              style="width:140px;height:140px;border-radius:8px;"
              fit="cover"
            />
          </div>
          <div v-else style="color:#94a3b8;">暂无图片</div>
        </el-card>

        <el-card style="width:100%;">
          <div style="font-weight:700;margin-bottom:8px;">日志</div>
          <el-timeline v-if="logs.length">
            <el-timeline-item v-for="it in logs" :key="it.id" :timestamp="it.cTime">
              <div style="font-weight:600;">{{ it.operateDesc }}</div>
              <div style="color:#64748b;font-size:12px;display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
                <span>{{ it.operatorName }}（{{ operatorTypeText(it.operatorType) }}）</span>
                <el-button
                  v-if="hasLogImages(it, images)"
                  type="text"
                  style="padding:0;"
                  @click="openLogImages(it, images, detail.orderCode)"
                >
                  图片
                </el-button>
              </div>
            </el-timeline-item>
          </el-timeline>
          <div v-else style="color:#94a3b8;">暂无日志</div>
        </el-card>
      </div>
    </el-dialog>

    <el-dialog
      :title="logsDlgTitle"
      :visible.sync="logsDlg"
      width="900px"
      destroy-on-close
    >
      <div v-loading="logsDlgLoading">
        <el-timeline v-if="logsDlgList.length">
          <el-timeline-item v-for="it in logsDlgList" :key="it.id" :timestamp="it.cTime">
            <div style="font-weight:600;">{{ it.operateDesc }}</div>
            <div style="color:#64748b;font-size:12px;display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
              <span>{{ it.operatorName }}（{{ operatorTypeText(it.operatorType) }}）</span>
              <el-button
                v-if="hasLogImages(it, logsDlgImages)"
                type="text"
                style="padding:0;"
                @click="openLogImages(it, logsDlgImages, currentLogsOrderCode)"
              >
                图片
              </el-button>
            </div>
          </el-timeline-item>
        </el-timeline>
        <div v-else style="color:#94a3b8;">暂无日志</div>
      </div>
    </el-dialog>

    <el-dialog
      :title="logImagesDlgTitle"
      :visible.sync="logImagesDlg"
      width="900px"
      destroy-on-close
    >
      <div v-if="logImagesDlgList.length" style="display:flex;gap:10px;flex-wrap:wrap;">
        <el-image
          v-for="it in logImagesDlgList"
          :key="it.id"
          :src="it.path"
          :preview-src-list="logImagesDlgPreview"
          style="width:160px;height:160px;border-radius:8px;"
          fit="cover"
        />
      </div>
      <div v-else style="color:#94a3b8;">暂无图片</div>
    </el-dialog>

    <el-dialog
      :title="imagesDlgTitle"
      :visible.sync="imagesDlg"
      width="900px"
      destroy-on-close
    >
      <div v-loading="imagesDlgLoading">
        <div v-if="imagesDlgList.length" style="display:flex;gap:10px;flex-wrap:wrap;">
          <el-image
            v-for="it in imagesDlgList"
            :key="it.id"
            :src="it.path"
            :preview-src-list="imagesDlgPreview"
            style="width:160px;height:160px;border-radius:8px;"
            fit="cover"
          />
        </div>
        <div v-else style="color:#94a3b8;">暂无图片</div>
      </div>
    </el-dialog>

    <el-dialog
      title="退款"
      :visible.sync="refundDlg"
      width="560px"
      destroy-on-close
    >
      <div v-loading="refundDlgLoading">
        <div style="color:#64748b;font-size:12px;margin-bottom:10px;line-height:1.5;">
          <div v-if="refundRow && refundRow.payStatus === 2">已支付订单将发起全额退款，并取消订单。</div>
          <div v-else>未支付订单无需退款，将直接取消订单。</div>
        </div>

        <el-form label-width="90px">
          <el-form-item label="退款理由">
            <el-select v-model="refundReasonOption" placeholder="请选择" style="width:100%;" @change="onRefundReasonOptionChange">
              <el-option v-for="it in refundReasonOptions" :key="it.value" :label="it.label" :value="it.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="补充说明">
            <el-input
              v-model="refundReasonText"
              type="textarea"
              :rows="4"
              placeholder="可自定义输入退款/取消原因"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDlg=false">取消</el-button>
        <el-button type="danger" :loading="refundDlgLoading" @click="submitRefund">确认</el-button>
      </span>
    </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

const STATUS_TEXT = {
  '1': '订单创建',
  '2': '订单确认',
  '3': '派单中',
  '4': '待取件',
  '5': '上门运输中',
  '6': '机场接收中',
  '7': '已送达机场',
  '8': '已出港',
  '9': '出港待领取',
  '10': '配送员接收中',
  '11': '末端运输中',
  '12': '送货完成',
  '31': '待取件',
  '32': '已取件',
  '33': '中转中',
  '34': '配送中',
  '20': '订单完成',
  '21': '订单取消',
  '22': '异常待处理',
  '23': '异常解决',
  '24': '订单作废'
}

export default {
  name: 'BizOrder',
  mixins: [tableAutoHeight],
  data() {
    return {
      STATUS_TEXT,
      keyword: '',
      orderType: null,
      status: '',
      payStatus: null,
      refundStatus: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      detailDlg: false,
      detail: {},
      logs: [],
      images: [],

      logsDlg: false,
      logsDlgTitle: '订单日志',
      logsDlgLoading: false,
      logsDlgList: [],
      logsDlgImages: [],
      currentLogsOrderCode: '',

      logImagesDlg: false,
      logImagesDlgTitle: '日志图片',
      logImagesDlgList: [],

      imagesDlg: false,
      imagesDlgTitle: '订单图片',
      imagesDlgLoading: false,
      imagesDlgList: [],

      refundDlg: false,
      refundDlgLoading: false,
      refundRow: null,
      refundReasonOption: 'custom',
      refundReasonText: '',
      refundReasonOptions: [
        { label: '客户要求退款', value: '客户要求退款' },
        { label: '重复下单', value: '重复下单' },
        { label: '信息填写错误', value: '信息填写错误' },
        { label: '价格/费用问题', value: '价格/费用问题' },
        { label: '其他（自定义）', value: 'custom' }
      ]
    }
  },
  computed: {
    imagesPreview() {
      return (this.images || []).map(it => it.path).filter(Boolean)
    },
    imagesDlgPreview() {
      return (this.imagesDlgList || []).map(it => it.path).filter(Boolean)
    },
    logImagesDlgPreview() {
      return (this.logImagesDlgList || []).map(it => it.path).filter(Boolean)
    }
  },
  created() {
    this.load()
  },
  methods: {
    reset() {
      this.keyword = ''
      this.orderType = null
      this.status = ''
      this.payStatus = null
      this.refundStatus = null
      this.pageNum = 1
      this.load()
    },
    async exportExcel() {
      if (this.exporting) return
      this.exporting = true
      try {
        const blob = await request.get('/admin/api/biz/order/export', {
          params: {
            keyword: this.keyword,
            orderType: this.orderType,
            status: this.status,
            payStatus: this.payStatus,
            refundStatus: this.refundStatus
          },
          responseType: 'blob'
        })

        // 后端若返回 ApiResult（json），这里会是 json blob，转成提示
        if (blob && blob.type && blob.type.indexOf('application/json') !== -1) {
          const text = await blob.text()
          try {
            const obj = JSON.parse(text)
            if (obj && obj.message) this.$message.error(obj.message)
            else this.$message.error('导出失败')
          } catch (e) {
            this.$message.error('导出失败')
          }
          return
        }

        const ts = new Date()
        const pad = (n) => (n < 10 ? '0' + n : '' + n)
        const name = '订单导出_' + ts.getFullYear() + pad(ts.getMonth() + 1) + pad(ts.getDate()) + '_' + pad(ts.getHours()) + pad(ts.getMinutes()) + pad(ts.getSeconds()) + '.xlsx'

        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } finally {
        this.exporting = false
      }
    },

    orderTypeText(v) {
      if (v === 1) return '门到港'
      if (v === 2) return '港到门'
      if (v === 3) return '不正常行李'
      if (v === 4) return '预留物品'
      return '-'
    },
    isReserved(row) {
      return Number(row && row.orderType) === 4
    },
    statusText(v) {
      return STATUS_TEXT[(v || '').toString()] || ((v || '').toString() || '-')
    },
    statusTagType(v) {
      const s = (v || '').toString()
      if (s === '20') return 'success'
      if (s === '21') return 'danger'
      if (s === '22' || s === '24') return 'warning'
      return 'info'
    },
    payStatusText(v) {
      if (v === 1) return '未支付'
      if (v === 2) return '已支付'
      return '-'
    },
    refundStatusText(v) {
      if (v === 1) return '未退款'
      if (v === 2) return '退款中'
      if (v === 3) return '退款成功'
      if (v === 4) return '退款失败'
      return '-'
    },
    refundTagType(v) {
      if (v === 3) return 'success'
      if (v === 2) return 'warning'
      if (v === 4) return 'danger'
      return 'info'
    },
    operatorTypeText(v) {
      const s = (v == null ? '' : v).toString()
      if (s === '1') return '用户'
      if (s === '2') return '管理员'
      if (s === '3') return '系统自动'
      if (s === '4') return '配送员'
      return s || '-'
    },
    airportText(cn, code) {
      const a = (cn || '').toString().trim()
      const b = (code || '').toString().trim()
      if (a && b) return a + '（' + b + '）'
      return a || b || '-'
    },
    flightDateText(row) {
      if (row && Number(row.orderType) === 3) return '-'
      return (row && row.flightDate) || '-'
    },
    parseDateTime(value) {
      if (!value) return null
      if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value
      const raw = String(value).trim()
      if (!raw) return null
      const date = raw.includes('-') && raw.includes(' ') && !raw.includes('T')
        ? new Date(raw.replace(/-/g, '/'))
        : new Date(raw)
      return Number.isNaN(date.getTime()) ? null : date
    },
    formatDateTime(value) {
      const date = this.parseDateTime(value)
      if (!date) return ''
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    formatHm(value) {
      const date = this.parseDateTime(value)
      if (!date) return ''
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return `${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    pickupTimeText(row) {
      const start = row && row.pickUpStartTime
      const end = row && row.pickUpEndTime
      if (!start && !end) return '-'
      if (start && end) {
        return `${this.formatDateTime(start)} ~ ${this.formatHm(end)}`
      }
      return this.formatDateTime(start || end) || '-'
    },
    normalizeStatus(v) {
      if (v === null || v === undefined) return ''
      return String(v).trim()
    },
    matchLogImages(logItem, sourceImages) {
      const status = this.normalizeStatus(logItem && logItem.currStatus)
      if (!status || !Array.isArray(sourceImages)) return []
      return sourceImages.filter((img) => {
        if (!img || !img.path) return false
        return this.normalizeStatus(img.status) === status
      })
    },
    hasLogImages(logItem, sourceImages) {
      return this.matchLogImages(logItem, sourceImages).length > 0
    },
    openLogImages(logItem, sourceImages, orderCode) {
      const matched = this.matchLogImages(logItem, sourceImages)
      if (!matched.length) {
        this.$message.info('当前日志暂无对应图片')
        return
      }
      const status = this.statusText(logItem && logItem.currStatus)
      this.logImagesDlgTitle = '日志图片' + (orderCode ? ' - ' + orderCode : '') + '（' + status + '）'
      this.logImagesDlgList = matched
      this.logImagesDlg = true
    },
    addressText(row, type) {
      const r = row || {}
      const cn = type === 'start' ? r.startAddressCn : r.endAddressCn
      if (cn) return cn

      const p = type === 'start' ? r.startProvinceName : r.endProvinceName
      const c = type === 'start' ? r.startCityName : r.endCityName
      const a = type === 'start' ? r.startAreaName : r.endAreaName
      const detail = type === 'start' ? r.startAddress : r.endAddress

      const parts = [p, c, a].filter(Boolean).join('')
      const d = (detail || '').toString().trim()
      const out = (parts + (d ? (parts ? ' ' : '') + d : '')).trim()
      return out || '-'
    },
    async load(page) {
      if (typeof page === 'number') this.pageNum = page
      const pageData = await request.get('/admin/api/biz/order/page', {
        params: {
          keyword: this.keyword,
          orderType: this.orderType,
          status: this.status,
          payStatus: this.payStatus,
          refundStatus: this.refundStatus,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })

      this.list = pageData.records || []
      this.total = pageData.total || 0
      this.$nextTick(() => this.updateTableHeight())
    },
    async openDetail(row) {
      this.detailDlg = true
      this.detail = {}
      this.logs = []
      this.images = []

      const [detail, logs, images] = await Promise.all([
        request.get('/admin/api/biz/order/' + row.id),
        request.get('/admin/api/biz/order/' + row.id + '/logs'),
        request.get('/admin/api/biz/order/' + row.id + '/images')
      ])
      this.detail = detail || {}
      this.logs = logs || []
      this.images = images || []
    },
    async openLogs(row) {
      const id = row && row.id
      if (!id) return

      this.logsDlg = true
      this.logsDlgTitle = '订单日志' + (row.orderCode ? ' - ' + row.orderCode : '')
      this.logsDlgList = []
      this.logsDlgImages = []
      this.currentLogsOrderCode = row.orderCode || ''
      this.logsDlgLoading = true
      try {
        const [logs, images] = await Promise.all([
          request.get('/admin/api/biz/order/' + id + '/logs'),
          request.get('/admin/api/biz/order/' + id + '/images')
        ])
        this.logsDlgList = logs || []
        this.logsDlgImages = images || []
      } finally {
        this.logsDlgLoading = false
      }
    },
    async openImages(row) {
      const id = row && row.id
      if (!id) return

      this.imagesDlg = true
      this.imagesDlgTitle = '订单图片' + (row.orderCode ? ' - ' + row.orderCode : '')
      this.imagesDlgList = []
      this.imagesDlgLoading = true
      try {
        const images = await request.get('/admin/api/biz/order/' + id + '/images')
        this.imagesDlgList = images || []
      } finally {
        this.imagesDlgLoading = false
      }
    },
    canRefund(row) {
      const r = row || {}
      const status = (r.status || '').toString()
      if (!r.id) return false
      if (status === '21') return false
      // 退款中/退款成功 不再允许重复操作
      if (r.refundStatus === 2 || r.refundStatus === 3) return false
      // 未支付/已支付都允许点：未支付会走“取消”，已支付走“退款+取消”
      return true
    },
    onRefundReasonOptionChange(v) {
      if (v === 'custom') {
        if (this.refundReasonText && this.refundReasonText !== '其他') return
        this.refundReasonText = ''
        return
      }
      this.refundReasonText = v || ''
    },
    openRefund(row) {
      this.refundRow = row || null
      this.refundDlg = true
      this.refundDlgLoading = false
      // 默认理由：已支付给一个常用理由；未支付给“取消原因”引导
      if (row && row.payStatus === 2) {
        this.refundReasonOption = '客户要求退款'
        this.refundReasonText = '客户要求退款'
      } else {
        this.refundReasonOption = '信息填写错误'
        this.refundReasonText = '信息填写错误'
      }
    },
    async submitRefund() {
      const row = this.refundRow || {}
      if (!row.id) return

      const reason = (this.refundReasonText || '').toString().trim()
      if (!reason) {
        this.$message.warning('请填写退款/取消原因')
        return
      }

      this.refundDlgLoading = true
      try {
        await request.post('/admin/api/biz/order/' + row.id + '/refund', { reason })
        this.$message.success(row.payStatus === 2 ? '已发起退款并取消订单' : '已取消订单')
        this.refundDlg = false
        await this.load()
        // 若当前打开了同一订单详情，顺便刷新
        if (this.detailDlg && this.detail && this.detail.id === row.id) {
          await this.openDetail({ id: row.id })
        }
      } finally {
        this.refundDlgLoading = false
      }
    }
  }
}
</script>

<style scoped>
.kv { display:flex; gap:12px; padding:6px 0; border-bottom:1px dashed #e5e7eb; }
.k { width:110px; flex: 0 0 auto; color:#64748b; }
.v { flex:1; color:#0f172a; word-break: break-word; }
</style>


